function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#EC6B01",
  d: "M15.472 5.417a.774.774 0 00-.518.218l-7.15 6.853a.7.7 0 000 1.02l7.15 6.854c.189.188.47.264.733.198a.738.738 0 00.539-.516.704.704 0 00-.207-.703L9.4 12.998l6.619-6.343a.698.698 0 00.168-.798.754.754 0 00-.715-.44z"
});

function SvgLoginBackinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26"
  }, props), _ref);
}

export default SvgLoginBackinline;